import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as lineSelectors, actions as lineActions } from 'ducks/salesOrderEnquiry/saleDeposits';
import { selectors as orderSelectors } from 'ducks/salesOrderEnquiry/salesOrder';
import { fetch } from 'api/salesOrderEnquiry/saleDeposits';

const params = new URLSearchParams(location.search);

export const mapStateToProps = state => ({
  gridName: 'SaleDeposits',
  columnDefs: lineSelectors.lineColumns(state),
  rowData: lineSelectors.lines(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state), //to trigger update size based on drawer state change
  gridOptions: lineSelectors.gridOptions(state),
  isLoading: lineSelectors.isLoading(state),
  reqParams: (orderSelectors.selected(state) || params.get('SalesOrder')) &&
  {
    SalesOrder: (orderSelectors.selected(state) && orderSelectors.selected(state).SalesOrder) || params.get('SalesOrder'),
  },
  keyFields: [{ valueField: 'TransactionNumber', routeField: 'TransactionNumber' }],
  apiMethod: fetch
});

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: lineActions.setSelected
}
